import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Paper, BottomNavigation, BottomNavigationAction, Box } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

function Navigation() {
    const navigate = useNavigate();
    const location = useLocation();
    const [value, setValue] = React.useState(location.pathname);

    React.useEffect(() => {
        setValue(location.pathname);
    }, [location.pathname]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        navigate(newValue);
    };

    return (
        <Box sx={{ pb: 7 }}>
            {/* Mobile Bottom Navigation */}
            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={handleChange}
                    sx={{
                        backgroundColor: 'background.paper',
                        '& .Mui-selected, & .Mui-selected .MuiBottomNavigationAction-label': {
                            color: 'primary.main',
                        },
                    }}
                >
                    <BottomNavigationAction
                        label="Groups"
                        value="/"
                        icon={<GroupsIcon />}
                    />
                    <BottomNavigationAction
                        label="Account"
                        value="/account"
                        icon={<AccountCircleIcon />}
                    />
                </BottomNavigation>
            </Paper>
        </Box>
    );
}

export default Navigation;
